import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ChangePasswordModel } from '../../../classes';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.css']
})
export class ChangePasswordDialogComponent implements OnInit {

  error: boolean = false;

  formGroup: FormGroup;

  constructor(
    private _dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
    private _userService: UserService,
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group(new ChangePasswordModel());
  }

  confirm(){
    this._userService
      .changeUserPassword(this.formGroup.value)
      .subscribe({
        next: () => this._dialogRef.close(true),
        error: () => this.error = true
      });
  }

  close = () => this._dialogRef.close(false);

  ngOnInit(): void {
  }

}
